import { render, staticRenderFns } from "./wB2mSelect2.vue?vue&type=template&id=ad71351e&scoped=true&"
import script from "./wB2mSelect2.vue?vue&type=script&lang=js&"
export * from "./wB2mSelect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad71351e",
  null
  
)

export default component.exports